/**
 * Normalizzazione e-mail (§24).
 *
 * Regola della specifica: trim, lowercase del **dominio**, validazione
 * sintattica ragionevole. L'indirizzo va conservato come fornito, più una forma
 * normalizzata per ricerca e duplicati.
 *
 * Conseguenza voluta della regola: `Mario@example.it` e `mario@example.it`
 * producono forme normalizzate diverse, perché la parte locale è
 * case-sensitive secondo RFC 5321 e la specifica non autorizza a
 * normalizzarla. Se il Titolare volesse una deduplicazione più aggressiva,
 * è una decisione da prendere e documentare, non da introdurre qui.
 *
 * Nessun enrichment, nessuna verifica invasiva della casella (§24).
 */
/** Validazione sintattica volutamente permissiva: rifiuta gli errori evidenti. */
const EMAIL_PATTERN = /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)+$/;
export function isPlausibleEmail(value) {
    const trimmed = value.trim();
    return trimmed.length <= 254 && EMAIL_PATTERN.test(trimmed);
}
export class InvalidEmailError extends Error {
    constructor() {
        // Nessun dato personale nel messaggio: finisce nei log e nelle risposte (§11.7).
        super('Indirizzo e-mail non valido.');
    }
}
export function normalizeEmail(value) {
    const original = value.trim();
    if (!isPlausibleEmail(original))
        throw new InvalidEmailError();
    const separator = original.lastIndexOf('@');
    const localPart = original.slice(0, separator);
    const domain = original.slice(separator + 1).toLowerCase();
    return { original, normalized: `${localPart}@${domain}` };
}
//# sourceMappingURL=email.js.map